import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { NavHeader } from "./NavHeader";
import { CtaFooter } from "./CtaFooter";
import { scrollToTopNow } from "../lib/nav";

export const Breadcrumbs = ({ items, dark = false }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className={`flex flex-wrap items-center gap-1.5 text-xs sm:text-sm mb-8 ${dark ? "text-white/60" : "text-[#0F172A]/55"}`}>
    <Link to="/" className={`${dark ? "hover:text-[#40C0E0]" : "hover:text-[#0090D0]"} transition-colors duration-300`}>Home</Link>
    {items.map((it) => (
      <React.Fragment key={it.label}>
        <ChevronRight size={14} className={dark ? "text-white/30" : "text-[#103080]/30"} />
        {it.to ? (
          <Link to={it.to} className={`${dark ? "hover:text-[#40C0E0]" : "hover:text-[#0090D0]"} transition-colors duration-300`}>{it.label}</Link>
        ) : (
          <span className={`font-medium ${dark ? "text-white" : "text-[#103080]"}`}>{it.label}</span>
        )}
      </React.Fragment>
    ))}
  </nav>
);

export const PageShell = ({ children, testid }) => {
  const { pathname } = useLocation();
  useEffect(() => { scrollToTopNow(); }, [pathname]);

  return (
    <div className="grain" data-testid={testid}>
      <NavHeader />
      <main className="pt-[72px]">{children}</main>
      <CtaFooter />
    </div>
  );
};

export const SubpageHero = ({ eyebrow, title, lead, crumbs, children, dark = false }) => (
  <section className={`${dark ? "bg-[#103080] text-white" : "bg-[#F5F2EB] border-b border-[#103080]/10"} py-16 sm:py-24`}>
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      {crumbs && <Breadcrumbs items={crumbs} dark={dark} />}
      <p className={`text-xs uppercase tracking-[0.3em] font-medium mb-5 ${dark ? "text-[#40C0E0]" : "text-[#0090D0]"}`}>{eyebrow}</p>
      <h1 className={`font-serif font-semibold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-4xl ${dark ? "text-white" : "text-[#103080]"}`} data-testid="page-title">
        {title}
      </h1>
      {lead && (
        <p className={`mt-7 text-base sm:text-lg leading-relaxed max-w-2xl ${dark ? "text-white/75" : "text-[#0F172A]/70"}`}>{lead}</p>
      )}
      {children}
    </div>
  </section>
);
